import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios'; // Import axios here
import DashboardLayout from '../Dashboard/layout';
import Swal from 'sweetalert2'; // Corrected import of Swal
//import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { Headings } from './ViewRegList';
import { Form } from 'react-bootstrap';
import { FaCopy, FaCheck } from "react-icons/fa";
import "./RegisteredUsersList.css"


const AddUserPage = () => {
  const [newUser, setNewUser] = useState({
    email: '',
    // password: '',
    // confirmPassword: '',
    invitationCode: '', 
    registerusercount: '0',   // Default value for registerBy
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  // const [showPassword, setShowPassword] = useState(false);
  // const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [copied, setCopied] = useState(false);

  // const togglePasswordVisibility = (setType) => {
  //   setType((prevState) => !prevState);
  // };

  const handleCopy = () => {
    navigator.clipboard.writeText(newUser.invitationCode)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset icon after 2 seconds
      })
      .catch((err) => console.error("Failed to copy:", err));
  };

  // Generate a random 12-character invitation code on page load
  useEffect(() => {
    const generateInvitationCode = () => {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let code = '';
      for (let i = 0; i < 12; i++) {
        code += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      setNewUser((prev) => ({ ...prev, invitationCode: code }));
    };

    generateInvitationCode(); // Generate code initially
  }, []);

  // Handle general input change
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setNewUser((prev) => ({ ...prev, [name]: value }));
  };

  // Basic validation
  const validateForm = () => {
    const newErrors = {};

    if (!newUser.email) newErrors.email = 'Email is required.';
    else if (!/\S+@\S+\.\S+/.test(newUser.email)) newErrors.email = 'Email is invalid.';
    // if (!newUser.password) newErrors.password = 'Password is required.';
    // if (newUser.password !== newUser.confirmPassword) newErrors.confirmPassword = 'Passwords do not match.';

    return newErrors;
  };

  // Form submission
  const handleAddUser = async (event) => {
    event.preventDefault();

    // Validate form and log errors
    const validationErrors = validateForm();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      try {
        const formData = new FormData();
        formData.append('email', newUser.email.toLowerCase());
        formData.append('invitationCode', newUser.invitationCode);
        formData.append('registerusercount', newUser.registerusercount);

        // Log form data for debugging
        console.log('Form Data:', newUser);
        console.log('FormData entries:');
        for (let pair of formData.entries()) {
          console.log(pair[0] + ': ' + pair[1]);
        }

        // Make the API call to add the user
        const res = await axios.post(
          `${process.env.REACT_APP_BASE_URL}api/admin/signup`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        // Check response status and show appropriate message
        if (res.data.status === 0) {
          // If the user already exists
          if (res.data.message === "User already exists") {
            Swal.fire({
              title: 'Error',
              text: 'User already exists!',
              icon: 'error',
              confirmButtonText: 'OK',
            });
          } else {
            // Handle other errors
            Swal.fire({
              title: 'Error',
              text: res.data.message || 'Something went wrong.',
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }

        } else {
      // Directly call the email API without user added alert
      try {
        
        const inviteResponse = await axios.post(
          `${process.env.REACT_APP_BASE_URL}api/admin/sendCongratulationsEmail`, 
          { email: newUser.email.toLowerCase(), invitationCode: newUser.invitationCode }
        );

        if (inviteResponse.data.status === 1) {
          Swal.fire('Email Sent!', 'A congratulations email with your invitation code has been sent!', 'success');
        } else {
          Swal.fire('Error', 'Failed to send the invitation email. Please try again later.', 'error');
        }
      } catch (error) {
        Swal.fire('Error', 'An error occurred while sending the invitation email.', 'error');
      }
      navigate('/ViewRegList');  
    }

  } catch (error) {
    console.error("Error submitting data", error);

    if (error.response) {
      Swal.fire("Error", error.response.data.message || "Something went wrong. Please try again.", "error");
    } else if (error.request) {
      Swal.fire("Error", "Unable to reach the server. Please check your internet connection.", "error");
    } else {
      Swal.fire("Error", "Something went wrong. Please try again.", "error");
    }
  }
} else {
  console.log('Form has errors, not submitting');
}
};








  // const handleAddUser = async (event) => {
  //   event.preventDefault();
  
  //   // Validate form and log errors
  //   const validationErrors = validateForm();
  //   setErrors(validationErrors);
  
  //   if (Object.keys(validationErrors).length === 0) {
  //     try {
  //       const formData = new FormData();
  //       formData.append('email', newUser.email);
  //       //formData.append('password', newUser.password);
  //       formData.append('invitationCode', newUser.invitationCode);
  //       formData.append('registerBy', newUser.registerBy);
  
  //       // Log form data for debugging
  //       console.log('Form Data:', newUser);
  //       console.log('FormData entries:');
  //       for (let pair of formData.entries()) {
  //         console.log(pair[0] + ': ' + pair[1]);
  //       }
  
  //       // Make the API call
  //       const res = await axios.post(
  //         `${process.env.REACT_APP_BASE_URL}api/admin/signup`,
  //         formData,
  //         {
  //           headers: {
  //             "Content-Type": "multipart/form-data",
  //           },
  //         }
  //       );
  
  //       // Check response status and show appropriate message
  //       if (res.data.status === 0) {
  //         // If the user already exists
  //         // Swal.fire({
  //         //   title: 'Error',
  //         //   text: 'User already exists!',
  //         //   icon: 'error',
  //         //   confirmButtonText: 'OK',
  //         // });
          
  //         // Check if the user already exists
  //       if (res.data.message === "User already exists") {
  //         Swal.fire({
  //           title: 'Error',
  //           text: 'User already exists!',
  //           icon: 'error',
  //           confirmButtonText: 'OK',
  //         });
  //       } else if (res.data.message === "Password did not conform with policy: Password must have lowercase characters") {
  //         // Handle password policy error
  //         Swal.fire({
  //           title: 'Error',
  //           text: 'Password must contain at least one lowercase letter. Please update your password.',
  //           icon: 'error',
  //           confirmButtonText: 'OK',
  //         });
  //       } else {
  //         // Handle other errors
  //         Swal.fire({
  //           title: 'Error',
  //           text: res.data.message || 'Something went wrong.',
  //           icon: 'error',
  //           confirmButtonText: 'OK',
  //         });
  //       }

  //       } else {
  //         // Swal.fire({
  //         //   title: 'Success',
  //         //   text: 'New User Added Successfully!',
  //         //   icon: 'success',
  //         //   confirmButtonText: 'OK',
  //         // });
  //         // navigate("/ViewRegList");
  //         // Display confirmation popup to confirm signup
  //         Swal.fire({
  //           title: 'User Added Successfully!',
  //           text: 'Please verify your email to complete the registration.',
  //           input: 'text',
  //           inputPlaceholder: 'Enter confirmation code',
  //           showCancelButton: true,
  //           confirmButtonText: 'Confirm Signup',
  //           cancelButtonText: 'Cancel',
  //         }).then(async (result) => {
  //           if (result.isConfirmed && result.value) {
  //             const confirmationCode = result.value;
  //             try {
  //               // Call the confirmSignup API with the entered code
  //               const confirmRes = await axios.post(
  //                 `${process.env.REACT_APP_BASE_URL}api/admin/confirmSignup`,
  //                 {
  //                   email: newUser.email,
  //                   confirmationCode: confirmationCode,
  //                 }
  //               );

  //               if (confirmRes.data.status === 1) {
  //                 // If the code is correct, show success message and navigate
  //                 Swal.fire({
  //                   title: 'Success',
  //                   text: confirmRes.data.message,
  //                   icon: 'success',
  //                   confirmButtonText: 'OK',
  //                 });
  //                 try {
  //                   const inviteResponse = await axios.post(`${process.env.REACT_APP_BASE_URL}api/admin/sendCongratulationsEmail`, { email: newUser.email, invitationCode: newUser.invitationCode });
  //                   if (inviteResponse.data.status === 1) {
  //                     Swal.fire('Email Sent!', 'A congratulations email with your invitation code has been sent!', 'success');
  //                   } else {
  //                     Swal.fire('Error', 'Failed to send the invitation email. Please try again later.', 'error');
  //                   }
  //                 } catch (error) {
  //                   Swal.fire('Error', 'An error occurred while sending the invitation email.', 'error');
  //                 }
  //                 navigate('/ViewRegList');
  //               } else {
  //                 // If the code is wrong, show an error message and prompt again
  //                 Swal.fire({
  //                   title: 'Error',
  //                   text: 'The confirmation code is incorrect. Please try again.',
  //                   icon: 'error',
  //                   confirmButtonText: 'OK',
  //                 }).then(() => {
  //                   // Reopen the input pop-up for retry
  //                   Swal.fire({
  //                     title: 'User Added Successfully!',
  //                     text: 'Please verify your email to complete the registration.',
  //                     input: 'text',
  //                     inputPlaceholder: 'Enter confirmation code',
  //                     showCancelButton: true,
  //                     confirmButtonText: 'Confirm Signup',
  //                     cancelButtonText: 'Cancel',
  //                   }).then(async (result) => {
  //                     if (result.isConfirmed && result.value) {
  //                       // Reattempt confirmation after retrying
  //                       const newConfirmationCode = result.value;
  //                       const retryConfirmRes = await axios.post(
  //                         `${process.env.REACT_APP_BASE_URL}api/admin/confirmSignup`,
  //                         {
  //                           email: newUser.email,
  //                           confirmationCode: newConfirmationCode,
  //                         }
  //                       );

  //                       if (retryConfirmRes.data.status === 1) {
  //                         Swal.fire({
  //                           title: 'Success',
  //                           text: retryConfirmRes.data.message,
  //                           icon: 'success',
  //                           confirmButtonText: 'OK',
  //                         });
  //                         try {
  //                           const inviteResponse = await axios.post(`${process.env.REACT_APP_BASE_URL}api/admin/sendCongratulationsEmail`, { email: newUser.email, invitationCode: newUser.invitationCode });
  //                           if (inviteResponse.data.status === 1) {
  //                             Swal.fire('Email Sent!', 'A congratulations email with your invitation code has been sent!', 'success');
  //                           } else {
  //                             Swal.fire('Error', 'Failed to send the invitation email. Please try again later.', 'error');
  //                           }
  //                         } catch (error) {
  //                           Swal.fire('Error', 'An error occurred while sending the invitation email.', 'error');
  //                         }
  //                         navigate('/ViewRegList');
  //                       } else {
  //                         Swal.fire({
  //                           title: 'Error',
  //                           text: 'The confirmation code is incorrect again. Please check the code.',
  //                           icon: 'error',
  //                           confirmButtonText: 'OK',
  //                         });
  //                       }
  //                     }
  //                   });
  //                 });
  //               }
  //             } catch (error) {
  //               Swal.fire({
  //                 title: 'Error',
  //                 text: 'There was an error confirming the signup. Please try again.',
  //                 icon: 'error',
  //                 confirmButtonText: 'OK',
  //               });
  //             }
  //           }
  //         });
  //       }
  
  //     } catch (error) {
  //       console.error("Error submitting data", error);
  
  //       // Handle different error scenarios
  //       if (error.response) {
  //         Swal.fire("Error", error.response.data.message || "Something went wrong. Please try again.", "error");
  //       } else if (error.request) {
  //         Swal.fire("Error", "Unable to reach the server. Please check your internet connection.", "error");
  //       } else {
  //         Swal.fire("Error", "Something went wrong. Please try again.", "error");
  //       }
  //     }
  //   } else {
  //     console.log('Form has errors, not submitting');
  //   }
  // };
  

  return (
    <DashboardLayout>

      <section className="MainDivSec">

        <Headings headspan="Add" hedtext=" New User " />

        <div className="AdduserFormDiv">

          <Form onSubmit={handleAddUser}>

            <div className="FormGroupDiv">
              <label>Email:</label>
              <input
                type="email"
                name="email"
                value={newUser.email}
                onChange={handleInputChange}
                autoComplete="off"
                autoCorrect="off"
                spellCheck="false"
                required
              />
              {errors.email && <span className="error-message">{errors.email}</span>}
            </div>

            {/* <div className="FormGroupDiv">
              <label>Password: </label>
              <div className="password_wrapper">
                <input type={showPassword ? "text" : "password"}
                  name="password"
                  value={newUser.password}
                  onChange={handleInputChange}
                  autoComplete="new-password"
                  required

                  /> 
                  
                <span className="toggle_icon"
                  onClick={() => togglePasswordVisibility(setShowPassword)}>
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
              {errors.password && <span className="error-message">{errors.password}</span>}
            </div> */}

            {/* <div className="FormGroupDiv">
              <label>Confirm Password: </label>
              <div className="password_wrapper">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  value={newUser.confirmPassword}
                  onChange={handleInputChange}
                  required />  
                <span
                  className="toggle_icon"
                  onClick={() => togglePasswordVisibility(setShowConfirmPassword)}>
                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
              {errors.confirmPassword && <span className="error-message">{errors.confirmPassword}</span>}
              
            </div> */}

            <div className="FormGroupDiv">
              <label>Invitation Code: </label>
              <div className="copint">
                <input
                  type="text"
                  name="invitationCode"
                  value={newUser.invitationCode}
                  onChange={handleInputChange}
                  readOnly
                />
                <div className="CopyIcon" onClick={handleCopy}>
                  <Link to="#">{copied ? <FaCheck style={{color:"green"}}  /> : <FaCopy />}</Link>
                </div>
              </div>
              
              {errors.invitationCode && <span className="error-message">{errors.invitationCode}</span>}
            </div>

            {/* Hidden field to send a value of 1 for registerBy */}
            <input type="hidden" name="registerusercount" value={newUser.registerusercount} />

            <div className="SubMit">
              <button type="submit">Add User</button>
            </div>

          </Form>

        </div>

      </section>

    </DashboardLayout>
  );
};

export default AddUserPage;
